<template>
  <div class="shortcuts-table mt-2">
    <div
      v-for="(table, index) of tableData"
      :key="index"
      class="mb-4"
    >
      <div>
        <span class="ap-title ap-title__section">
          {{ table.tableTitle }}
        </span>
      </div>
      <b-row class="table-header my-1">
        <b-col cols="4">
          <span>{{ $t('component.shortcutsModal.action') }}</span>
        </b-col>
        <b-col cols="4">
          <span>{{ $t('component.shortcutsModal.shortcut') }}</span>
        </b-col>
        <b-col cols="4">
          <span>{{ $t('component.shortcutsModal.voiceCommand') }}</span>
        </b-col>
      </b-row>
      <b-row
        v-for="(element, indexElement) of table.tableElements"
        :key="indexElement"
        class="table-row"
      >
        <b-col cols="4">
          <span class="label-dark">{{ element.action }}</span>
        </b-col>
        <b-col
          cols="4"
          class="d-flex"
        >
          <div
            v-for="(shortcut, indexShorcut) of element.shortcuts"
            :key="indexShorcut"
            class="d-flex align-items-center"
            :class="{'shortcut-key':shortcut.key}"
          >
            <div class="key">
              <span v-if="shortcut.icon"><i
                class="px-1"
                :class="shortcut.key"
                aria-hidden="true"
              /></span>
              <span
                v-if="!shortcut.icon"
                class="label-dark"
              >{{ shortcut.key }}</span>
            </div>
            <span
              v-if="shortcut.key"
              class="plus mx-1"
            >+</span>
            <span
              v-if="!shortcut.key"
              class="plus mx-1"
            >-</span>
          </div>
        </b-col>
        <b-col cols="4">
          <span class="label-dark">{{ element.voiceCommand }}</span>
        </b-col>
        <b-col cols="12">
          <hr class="my-2">
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
    name: 'ShortcutsAndVoiceCommandsTable',
    props: {
        tableData: { type: Array }
    },
    data() {
        return {
        }
    }
}
</script>

<style lang="scss">
    .shortcuts-table .table-title {
        color: vt-color(primary);
        font-size: font-size(very-small);
        font-style: italic;
    }
    .shortcuts-table .table-header span {
        text-transform: uppercase;
        font-size: font-size(very-tiny);
    }
    .shortcuts-table .table-row {
        color: vt-color(dark-text);
        font-size: font-size(very-small);
    }
    .shortcuts-table .shortcut-key .key{
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 5px;
        box-shadow: 0px 1px 1px 0px #9c9c9c;
        padding: 3px;
        min-width: 30px;
        text-align: center;
    }
    .shortcuts-table .shortcut-key:last-child .plus{
        display: none;
    }
    .shortcuts-table .shortcut-key .key .fa-level-down{
        transform: rotate(90deg);
    }
</style>
